<template>
    <div class="no-drive">
        <img src="@/assets/img/no-drive.svg">
        <span>禁止酒駕 飲酒過量 有害健康</span>
    </div>
</template>

<script>
    export default {
        name: "NoDrive"
    }
</script>

<style lang="scss" scoped>
    .no-drive {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 10vh;
        background-color: #000;
        color: #fff;
        font-size: 3vh;
        position: fixed;
        width: 100%;
        z-index: 99;

        img {
            height: 5vh;
            margin-right: 15px;
        }
    }
</style>